import React from "react";

function FAQBody() {
  return (
    <>
      <div className="container-fluid  p-4 body-font">
        <div
          className="row p-4"
          style={{
            width: "100vw",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="row img-fluid"
            style={{
              backgroundImage:
                "url(https://images.hertz.com/content/dam/hod/images/en-gb/static/FAQ_top.png)",
              backgroundSize: "cover",
            }}
          >
            <div className="col-xs-12 col-md-1"></div>
            <div className="col-xs-12 col-md-5">
              <br />
              <p className="h6">
                <b>FAQs</b>
              </p>
              <p className="h1">
                <b>Mehr erfahren</b>
              </p>
              <p>
                Wir verstehen, dass Sie vielleicht Fragen zur Funktionsweise von
                Hertz 24/7, Bedenken bezüglich Ihrer Rechnungen haben oder
                einfach nur wissen möchten, was für die Registrierung
                erforderlich ist. Diese Seite wird diese Fragen beantworten.
              </p>

              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
            <div className="col-xs-12 col-md-4"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <br />
            <br />

            <p>
              <a href="#reg" style={{ textDecoration: "none" }}>
                Registrierung
              </a>
            </p>
            <hr />
            <p>
              <a href="#book" style={{ textDecoration: "none" }}>
                Ihre Buchung
              </a>
            </p>
            <hr />
            <p>
              <a href="#yj" style={{ textDecoration: "none" }}>
                Ihre Anmietung
              </a>
            </p>
            <hr />
            <p>
              <a href="#bfi" style={{ textDecoration: "none" }}>
                Abrechnung, Gebühren und Versicherung
              </a>
            </p>
            <hr />
            <p>
              <a href="#consup" style={{ textDecoration: "none" }}>
                Support kontaktieren
              </a>
            </p>
            <hr />
            <p>
              <a href="#aob" style={{ textDecoration: "none" }}>
                Unfälle/Pannen
              </a>
            </p>
            <hr />
            <p>
              <a href="#cg" style={{ textDecoration: "none" }}>
                Richtlinien
              </a>
            </p>
            <hr />
          </div>

          <div className="col-xs-12 col-md-9" style={{ textAlign: "left" }}>
            <br />
            <br />

            <div className="accordion p-4" id="accordionFlushExample">
              <br />
              <p id="reg">
                <b>Registrierung</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse1"
                    aria-expanded="false"
                    aria-controls="flush-collapse1"
                  >
                    <b>Was ist Hertz 24/7?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse1"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading1"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Hertz 24/7® ist das Carsharing Produkt von Hertz®, das Ihnen
                    den Komfort und die Flexibilität bietet, auf eine große
                    Auswahl an Transportern und Fahrzeugen zuzugreifen. Sie
                    können stunden- bis tageweise mieten. Die Abholung ist rund
                    um die Uhr möglich (je nach Öffnungszeiten des jeweiligen
                    Standorts). Mit Hertz 24/7 buchen und verwalten Sie Ihre
                    Anmietung ganz einfach über die 24/7-App. Unser Ziel ist es,
                    dass Sie bereits 15 Minuten nach dem Herunterladen der App
                    losfahren können.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse2"
                    aria-expanded="false"
                    aria-controls="flush-collapse2"
                  >
                    <b>Was brauche ich um Hertz 24/7 nutzen zu können?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse2"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading2"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Um Hertz 24/7 nutzen zu können, benötigen wir die folgenden
                    Dokumente von Ihnen:
                    <br />
                    · Einen auf Ihren Namen ausgestellten gültigen Führerschein
                    & Ausweis (alternativ Pass + Adressnachweis)
                    <br />
                    · Eine Kredit-, Debitkarte oder PayPal Konto auf Ihren
                    eigenen Namen
                    <br />
                    · Ihre Mobilfunknummer und Ihre persönliche E-Mail-Adresse
                    <br />
                    Während Ihrer Registrierung führen wir die notwendigen
                    Identitätsprüfungen durch, bevor wir Ihre Registrierung
                    bestätigen
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse3"
                    aria-expanded="false"
                    aria-controls="flush-collapse3"
                  >
                    <b>
                      Wie erfahre ich, ob meine Registrierung vollständig
                      abgeschlossen ist?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse3"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading3"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sobald Ihre Registrierung vollständig abgeschlossen ist,
                    schicken wir Ihnen eine Push Nachricht und eine E-Mail.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse4"
                    aria-expanded="false"
                    aria-controls="flush-collapse4"
                  >
                    <b>
                      Was passiert, wenn sich meine Kontaktinformationen ändern?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse4"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading4"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sie können Ihre Kontaktdaten jederzeit in unserer App in
                    Ihrem Profil ändern.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse5"
                    aria-expanded="false"
                    aria-controls="flush-collapse5"
                  >
                    <b>
                      Hat meine Mitgliedschaft bei Hertz 24/7 eine Laufzeit?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse5"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading5"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Ihre Mitgliedschaft ist unbegrenzt. Solange Ihr Führerschein
                    gültig ist und Sie unsere Mietbedingungen erfüllen, können
                    Sie Hertz 24/7 nutzen.
                    <br />
                    Andere Bedingungen können gelten.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading7">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse7"
                    aria-expanded="false"
                    aria-controls="flush-collapse7"
                  >
                    <b>Wie alt muss ich sein, um ein Fahrzeug zu mieten?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse7"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading7"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sie müssen mindestens 19 Jahre alt sein, um eines unserer
                    Fahrzeuge mieten und fahren zu können. Außerdem müssen Sie
                    seit mindestens einem Jahr im Besitz eines gültigen
                    Führerscheins sein.
                  </div>
                </div>
              </div>

              <br />
              <p id="book">
                <b>Ihre Buchung</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading9">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse9"
                    aria-expanded="false"
                    aria-controls="flush-collapse9"
                  >
                    <b>
                      Was ist, wenn das gewünschte Fahrzeug bereits gebucht ist?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse9"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading9"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Wenn das Fahrzeug, das Sie buchen möchten, zu dem
                    gewünschten Zeitraum nicht verfügbar ist, wird Ihnen ein
                    alternativer Zeitraum angezeigt. Sie können auch die
                    Verfügbarkeit an einem Ort in der Nähe prüfen.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading10">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse10"
                    aria-expanded="false"
                    aria-controls="flush-collapse10"
                  >
                    <b>Wie erfahre ich, ob meine Reservierung bestätigt ist?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse10"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading10"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sie sehen den Status Ihrer Reservierung in der Hertz 24/7
                    App. Außerdem senden wir Ihnen eine Reservierungsbestätigung
                    per E-Mail.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading11">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse11"
                    aria-expanded="false"
                    aria-controls="flush-collapse11"
                  >
                    <b>
                      Gibt es Gebühren für die Änderung oder Stornierung meiner
                      Buchung?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse11"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading11"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sie können Ihre Buchung bis zur gebuchten Abholzeit
                    kostenlos ändern oder stornieren. Bei einer Stornierung
                    innerhalb des reservierten Zeitraums behalten wir uns vor
                    Stornogebühren zu erheben. Diese werden Ihnen in der App
                    angezeigt.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading12">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse12"
                    aria-expanded="false"
                    aria-controls="flush-collapse12"
                  >
                    <b>Ist meine Zahlung sicher?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse12"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading12"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Ja. Wir nutzen Stripe für alle Zahlungsprozesse. Stripe
                    erfüllt die strengsten Sicherheitsstandards der Branche, wie
                    z.B. Daten mit starker Verschlüsselung ( PCI DSS-konform).
                    Wir befolgen alle geltenden Datenschutzgesetze in Bezug auf
                    persönliche und finanzielle Daten.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading13">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse13"
                    aria-expanded="false"
                    aria-controls="flush-collapse13"
                  >
                    <b>
                      Wie werden mir die Kosten berechnet, wenn ich eine Hertz
                      24/7-Miete buche?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse13"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading13"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vor Mietbeginn autorisieren wir auf Ihrem Zahlungsmittel
                    einen Betrag in Höhe von 150 % der voraussichtlichen
                    Mietkosten, mindestens jedoch 150 €. Dieser Betrag wird
                    lediglich blockiert, jedoch nicht abgebucht. Die hinterlegte
                    Summe dient als Kaution für eventuell anfallende
                    Zusatzkosten, beispielsweise für Mehrkilometer oder
                    fehlenden Kraftstoff. Die Vorautorisierung wird bei
                    Rechnungsstellung freigegeben. Wir ziehen die Gebühren ab
                    und erstatten den Restbetrag. Wenn die Mietkosten die
                    Kaution übersteigen, werden wir den übersteigenden Betrag
                    separat abbuchen. Stellen Sie sicher, dass der gesamte
                    Betrag verfügbar ist, da die Miete sonst nicht beginnen
                    kann.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading14">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse14"
                    aria-expanded="false"
                    aria-controls="flush-collapse14"
                  >
                    <b>Wie lange im Voraus kann ich ein Fahrzeug buchen?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse14"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading14"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Standortabhängig zwischen drei und sechs Monaten.
                  </div>
                </div>
              </div>

              <br />
              <p id="yj">
                <b>Ihre Anmietung</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading15">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse15"
                    aria-expanded="false"
                    aria-controls="flush-collapse15"
                  >
                    <b>Wie entriegelt man das Fahrzeug?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse15"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading15"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Die Hertz 24/7-App ist Ihr digitaler Schlüssel. Um Ihr
                    Fahrzeug zu öffnen, drücken Sie während der Anmietung in der
                    Registerkarte "Fahren" die Taste "Öffnen". Hinweis: Sie
                    können das Auto erst öffnen, wenn die Mietzeit offiziell
                    begonnen hat, die Inspektion abgeschlossen ist und der
                    Vertrag unterzeichnet wurde. Vergewissern Sie sich,
                    dass&nbsp;
                    <b>Bluetooth</b> aktiviert ist und die App auch die Rechte
                    hat dieses zu nutzen. Wenn die App keine Verbindung aufbauen
                    kann, obwohl Bluetooth eingeschaltet ist, gehen Sie bitte in
                    die App "Einstellungen" und suchen sie unter Apps HERTZ 24/7
                    und aktivieren Sie die Bluetooth-Option. Sie müssen sich
                    innerhalb von 5 Metern vom Fahrzeug befinden.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading16">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse16"
                    aria-expanded="false"
                    aria-controls="flush-collapse16"
                  >
                    <b>Wo finde ich die Schlüssel?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse16"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading16"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sie finden die Schlüssel im Fahrzeug im Schlüsselhalter im
                    Handschuhfach. Hier muss der Schlüssel beim Mietende auch
                    wieder eingesteckt werden.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading17">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse17"
                    aria-expanded="false"
                    aria-controls="flush-collapse17"
                  >
                    <b>Wie kann ich das Fahrzeug starten?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse17"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading17"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Bei Fahrzeugen mit einem Zündschloss finden Sie den
                    Schlüssel im Schlüsselhalter im Handschuhfach. Treten Sie
                    das Brems- und Kupplungspedal (bei Automatikgetrieben nur
                    das Bremspedal) und drücken Sie den Startknopf oder starten
                    Sie den Motor mit dem Schlüssel. Wenn das Fahrzeug nicht
                    anspringt, ist möglicherweise die Wegfahrsperre aktiviert.
                    Drücken Sie in der Hertz 24/7-App auf dem Fahrbildschirm die
                    Power-Taste (zwischen Öffnen & Schließen), um die
                    Wegfahrsperre zu deaktivieren. Das Fahrzeug sollte nun
                    anspringen. HINWEIS: Bei einigen Elektrofahrzeugen, wie z.B.
                    bei TESLA oder POLESTAR gibt es keine separate Starttaste.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading18">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse18"
                    aria-expanded="false"
                    aria-controls="flush-collapse18"
                  >
                    <b>Was ist, wenn das Fahrzeug nicht anspringt?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse18"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading18"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Das Fahrzeug verfügt über eine Sicherheitsfunktion, die die
                    Wegfahrsperre aktiviert, wenn die Zündung für mehr als 2
                    Minuten ausgeschaltet ist. Um den Motor bei einer
                    Wegfahrsperre wieder zu starten, ziehen Sie den Schlüssel
                    aus dem Zündschloss und verwenden Sie die App, um die
                    Wegfahrsperre zu deaktivieren, indem Sie auf das Symbol
                    "Power" auf dem Fahrbildschirm drücken (das Symbol zwischen
                    den Symbolen zum Ver- und Entriegeln). Alternativ können Sie
                    das Fahrzeug auch über die App ver- und entriegeln. Wenn das
                    Fahrzeug immer noch nicht anspringt, wenden Sie sich an
                    unser Kundenservice Center.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading19">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse19"
                    aria-expanded="false"
                    aria-controls="flush-collapse19"
                  >
                    <b>Wie kann ich das Fahrzeug finden?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse19"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading19"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Ihre Buchungsbestätigung enthält Angaben dazu, wo Sie das
                    Fahrzeug finden. Diese Information steht Ihnen auch in der
                    App zur Verfügung. Sobald Ihr Fahrzeug für Sie bereitsteht,
                    können sie dieses auch über die Funktion "Fahrzeug finden"
                    orten.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading20">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse20"
                    aria-expanded="false"
                    aria-controls="flush-collapse20"
                  >
                    <b>Was ist, wenn das gebuchte Fahrzeug nicht da ist?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse20"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading20"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Bitte nutzen Sie die Funktion "Fahrzeug finden" um das
                    Fahrzeug zu orten. Wenn Sie Ihr Fahrzeug immer noch nicht
                    finden können, wenden Sie sich bitte an unser Kundenservice
                    Center.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading21">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse21"
                    aria-expanded="false"
                    aria-controls="flush-collapse21"
                  >
                    <b>
                      Was passiert, wenn ich das Fahrzeug zu spät zurückbringe?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse21"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading21"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Wenn Sie merken das es später wird, verlängern Sie bitte
                    Ihre Anmietung in der App. Eine Verlängerung ist nur
                    möglich, wenn es keine Folgereservierung gibt und der
                    Standort bei Rückgabe noch geöffnet ist. Wenn Sie das von
                    Ihnen reservierte Zeitfenster überschreiten, ohne die Miete
                    vorher zu verlängern, wird Ihnen die zusätzliche Zeit, in
                    der Sie das Fahrzeug nutzen, und eine Verspätungsgebühr
                    berechnet.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading22">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse22"
                    aria-expanded="false"
                    aria-controls="flush-collapse22"
                  >
                    <b>
                      Macht es etwas aus, wenn ich das Fahrzeug zu spät abhole?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse22"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading22"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Pläne können sich ändern. Wenn Sie sich verspäten, können
                    Sie die Abholzeit vor der ursprünglichen Abholzeit jederzeit
                    in der App anpassen. Nach mind. 2 Stunden Verspätung wird
                    das Fahrzeug jedoch wieder freigegeben.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading23">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse23"
                    aria-expanded="false"
                    aria-controls="flush-collapse23"
                  >
                    <b>Wer kommt für die Treibstoffkosten auf?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse23"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading23"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Kraftstoff ist in unseren Tarifen nicht inkludiert. Das
                    Fahrzeug wird mit vollem Tank übernommen und muss mit vollem
                    Tank abgegeben werden. Für Elektrofahrzeuge können Ausnahmen
                    gelten, die Sie bitte Ihrer Buchung entnehmen.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading24">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse24"
                    aria-expanded="false"
                    aria-controls="flush-collapse24"
                  >
                    <b>
                      Was ist, wenn der Tank des Fahrzeugs bei Abholung nicht
                      voll ist?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse24"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading24"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Wenn der Tank der Abholung des Fahrzeugs nicht ganz voll
                    sein sollte, bitten wir Sie das Fahrzeug bei Rückgabe
                    trotzdem voll zu tanken und uns den Tankbeleg zuzusenden.
                    Wir werden Ihnen dann die Differenz erstatten.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading30">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse30"
                    aria-expanded="false"
                    aria-controls="flush-collapse30"
                  >
                    <b>Stellen Sie Kindersitze zur Verfügung?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse30"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading30"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nein. Sie können aber gerne Ihre eigenen verwenden.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading31">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse31"
                    aria-expanded="false"
                    aria-controls="flush-collapse31"
                  >
                    <b>Darf ich Haustiere im Fahrzeug mitnehmen?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse31"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading31"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nein. Haustiere sind in unseren Fahrzeugen nicht erlaubt,
                    mit Ausnahme von Assistenzhunden.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading34">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse34"
                    aria-expanded="false"
                    aria-controls="flush-collapse34"
                  >
                    <b>Kann ich das Fahrzeug vorzeitig zurückgeben?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse34"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading34"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Ja, Sie können das Fahrzeug jederzeit während Ihrer
                    Mietdauer zurückgeben. Allerdings wird trotzdem der gesamte
                    Buchungszeitraum berechnet.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading35">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse35"
                    aria-expanded="false"
                    aria-controls="flush-collapse35"
                  >
                    <b>Wie kann ich meinen Mietvertrag verlängern?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse35"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading35"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Je nach Verfügbarkeit des Fahrzeugs können Sie Ihre
                    Anmietung ganz einfach über die Hertz 24/7 App verlängern.
                    Folgen Sie den Schritten nach dem Sie auf die Schaltfläche
                    "Miete verlängern" getippt haben.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading36">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse36"
                    aria-expanded="false"
                    aria-controls="flush-collapse36"
                  >
                    <b>Wo soll ich das Fahrzeug zurückgeben?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse36"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading36"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Bitte geben Sie das Fahrzeug auf dem dafür vorgesehenen
                    Hertz 24/7-Parkplatz am Standort ab. Falls es keinen
                    ausgewiesenen Parkplatz gibt, stellen Sie das Fahrzeug bitte
                    wieder dort ab wo Sie es auch abgeholt haben.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading37">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse37"
                    aria-expanded="false"
                    aria-controls="flush-collapse37"
                  >
                    <b>
                      Was ist, wenn der mir zugewiesene Stellplatz bereits
                      belegt ist?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse37"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading37"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Bitte parken Sie das Fahrzeug möglichst nah zu dem
                    zugewiesenen Parkplatz.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading38">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse38"
                    aria-expanded="false"
                    aria-controls="flush-collapse38"
                  >
                    <b>
                      Was ist, wenn das von mir gebuchte Fahrzeug vom Kunden vor
                      mir verspätet zurückgegeben wird?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse38"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading38"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Wir werden immer versuchen, Sie rechtzeitig zu erreichen, um
                    Ihnen Bescheid zu geben. Wenn Sie jedoch nichts von uns
                    gehört haben, kontaktieren Sie uns bitte so schnell wie
                    möglich und wir werden ein alternatives Fahrzeug
                    organisieren.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading39">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse39"
                    aria-expanded="false"
                    aria-controls="flush-collapse39"
                  >
                    <b>
                      Sollte ich die Schlüssel jemals zum Ver- und Entriegeln
                      des Fahrzeugs verwenden?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse39"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading39"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nein. Wenn Sie dies tun, kann es zu Problemen während der
                    Anmietung kommen. Die Schlüssel müssen zu jeder Zeit im
                    Fahrzeug verbleiben. Bitte verwenden Sie die Hertz 24/7-App,
                    um das Fahrzeug während Ihrer Anmietung zu ver- und
                    entriegeln. HINWEIS: Bei Inaktivität kann sich die
                    Wegfahrsperre des Fahrzeugs einschalten. Um diese zu
                    deaktivieren, drücken Sie bitte die Power"-Taste auf dem
                    "Fahren" Bildschirm in der App.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading40">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse40"
                    aria-expanded="false"
                    aria-controls="flush-collapse40"
                  >
                    <b>Wie werden Ihre Fahrzeuge gewartet?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse40"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading40"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Ein Team von engagierten Fachleuten kümmert sich um unsere
                    Hertz 24/7-Fahrzeugflotte. Zusätzlich zu unserer üblichen
                    planmäßigen Wartung führen wir monatlich einen 40-Punkte-
                    Qualitätscheck an jedem Fahrzeug durch.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading41">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse41"
                    aria-expanded="false"
                    aria-controls="flush-collapse41"
                  >
                    <b>Was tue ich, wenn ich eine Panne habe?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse41"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading41"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Bitte kontaktieren Sie uns bei einer Panne. Die Kontaktdaten
                    finden Sie in der App unter Hilfe-&gt;Kontakt.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading44">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse44"
                    aria-expanded="false"
                    aria-controls="flush-collapse44"
                  >
                    <b>Kann ich Hertz 24/7 auch in anderen Ländern nutzen?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse44"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading44"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Ja. Wenn Sie bei uns registriert sind, können Sie derzeit
                    Hertz 24/7 an allen teilnehmenden Standorten in den USA,
                    Vereinigtes Königreich, Frankreich, Deutschland, Belgien,
                    Italien und Portugal nutzen.
                  </div>
                </div>
              </div>

              <br />
              <p id="bfi">
                <b>Abrechnung, Gebühren und Versicherung</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading47">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse47"
                    aria-expanded="false"
                    aria-controls="flush-collapse47"
                  >
                    <b>
                      Gibt es irgendwelche zusätzlichen Kosten, die ich beachten
                      muss?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse47"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading47"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Zusätzliche Gebühren wie z.B. Kosten für gefahrene
                    Kilometer, Versicherungsgebühren werden Ihnen im
                    Buchungsprozess angezeigt. Des Weiteren gelten unsere
                    Zusatzgebühren wie z.B. für verspätete Rückgabe oder
                    Nichtbetankung des Fahrzeugs, welche Sie in unseren
                    Nutzungsbedingungen finden.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading49">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse49"
                    aria-expanded="false"
                    aria-controls="flush-collapse49"
                  >
                    <b>Muss ich eine Selbstbeteiligung zahlen?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse49"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading49"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Bei Beschädigung, Verlust oder Diebstahl des Fahrzeugs
                    müssen Sie eine Selbstbeteiligung gemäß Ihrer bei Buchung
                    abgeschlossenen Versicherung zahlen. Wenn die Reparatur
                    weniger als die Selbstbeteiligung beträgt, erstatten wir
                    Ihnen die Differenz abzüglich einer Verwaltungsgebühr.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading50">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse50"
                    aria-expanded="false"
                    aria-controls="flush-collapse50"
                  >
                    <b>Was deckt die Versicherung meiner Buchung ab?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse50"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading50"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Die Versicherung kommt für Schäden am Fahrzeug auf, die über
                    die Selbstbeteiligung hinausgehen. Die Selbstbeteiligung ist
                    der Höchstbetrag, den Sie im Schadensfall zu zahlen haben,
                    vorausgesetzt Sie halten sich an die Bedingungen Ihres
                    Mietvertrags. Sie sind auch durch die
                    Haftpflichtversicherung geschützt, die standardmäßig
                    enthalten und gesetzlich vorgeschrieben ist. Diese deckt
                    Schäden an anderen Fahrzeugen, anderem Eigentum und
                    verletzten Personen im Falle eines Unfalls ab. Wenn der
                    Verlust, die Beschädigung oder der Diebstahl des Fahrzeugs
                    vorsätzlich verursacht wird, Sie den falschen Kraftstoff in
                    das Fahrzeug einfüllen, den Kraftstofftank oder Ad-Blue Tank
                    verunreinigen, wird dies als grobe Fahrlässigkeit
                    eingestuft.
                  </div>
                </div>
              </div>

              <br />
              <p id="consup">
                <b>Support kontaktieren</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading29">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse29"
                    aria-expanded="false"
                    aria-controls="flush-collapse29"
                  >
                    <b>
                      Was ist, wenn ich etwas im Fahrzeug finde oder etwas von
                      mir zurücklasse?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse29"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading29"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Das ist kein Problem. Wenden Sie sich einfach an unser Team
                    und wir unterstützen Sie bei der Wiederbeschaffung wenn Sie
                    etwas im Fahrzeug vergessen haben. Bei einem Fundstück
                    kontaktieren den Vormieter, der den Gegenstand
                    zurückgelassen hat.
                  </div>
                </div>
              </div>

              <br />
              <p id="aob">
                <b>Unfälle/Pannen</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading27">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse27"
                    aria-expanded="false"
                    aria-controls="flush-collapse27"
                  >
                    <b>
                      Was passiert, wenn ich einen Strafzettel für zu schnelles
                      Fahren oder einen Strafzettel für Falschparken bekomme?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse27"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading27"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Mautgebühren, Strafzettel, Bußgelder sind in Ihrer
                    Verantwortung und von Ihnen zu zahlen.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading42">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse42"
                    aria-expanded="false"
                    aria-controls="flush-collapse42"
                  >
                    <b>
                      Was muss ich tun, wenn ich einen Unfall / Zwischenfall
                      habe?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse42"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading42"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Im Falle eines Unfalls kontaktieren Sie bitte zwingend die
                    Polizei. Danach wenden Sie sich bitte sofort an das Hertz
                    24/7-Team, indem Sie die Kontaktdaten im Bereich "Hilfe" der
                    App verwenden. Wir werden uns dann um alles kümmern. Stellen
                    Sie sicher, dass Sie die Details der dritten Partei, die in
                    den Unfall verwickelt ist, aufnehmen und Fotos von den
                    Schäden an beiden Fahrzeugen machen. Wenn Sie einen Vorfall
                    nicht melden, kann Ihr Versicherungsschutz erlöschen.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading43">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse43"
                    aria-expanded="false"
                    aria-controls="flush-collapse43"
                  >
                    <b>Was sollte ich tun, wenn das Fahrzeug gestohlen wird?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse43"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading43"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Bei einem Diebstahl kontaktieren Sie uns bitte unverzüglich
                    über die Kontaktdaten in der App unter Hilfe -&gt; Kontakt.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading45">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse45"
                    aria-expanded="false"
                    aria-controls="flush-collapse45"
                  >
                    <b>
                      Muss ich eine Gebühr bezahlen, wenn das Fahrzeug
                      abgeschleppt oder festgehalten wird?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse45"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading45"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Wir zahlen zunächst Abschlepp- und Strafgebühren und stellen
                    sie dann zusammen mit einer Verwaltungsgebühr Ihnen in
                    Rechnung.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading46">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse46"
                    aria-expanded="false"
                    aria-controls="flush-collapse46"
                  >
                    <b>
                      Muss ich eine Gebühr für die verspätete Rückgabe zahlen,
                      wenn das Fahrzeug eine Panne hat?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse46"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading46"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nein. Im Falle einer Panne müssen Sie keine zusätzlichen
                    Kosten tragen (es sei denn, Sie haben die Panne verursacht).
                    Die 24-Stunden-Notfall-Pannenhilfe ist in Ihrer Buchung
                    inklusive.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading48">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse48"
                    aria-expanded="false"
                    aria-controls="flush-collapse48"
                  >
                    <b>
                      Übernimmt meine private Kfz-Versicherung die Kosten für
                      den Schaden?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse48"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading48"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nein. Ihre persönliche Kfz-Versicherung gilt nicht für Hertz
                    24/7-Fahrzeuge. Unsere Fahrzeuge sind nur durch die
                    Versicherungspolicen abgedeckt, die wir im Zusammenhang mit
                    Ihrer Buchung anbieten oder zur Verfügung stellen.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading51">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse51"
                    aria-expanded="false"
                    aria-controls="flush-collapse51"
                  >
                    <b>
                      Kann ich mich auf die Versicherung meines
                      Kreditkartenanbieters verlassen, um einen Schaden zu
                      decken?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse51"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading51"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Erkundigen Sie sich am besten bei Ihrem
                    Kreditkartenanbieter, bevor Sie Ihre Hertz 24/7-Buchung
                    vornehmen, denn verschiedene Kreditkarten haben
                    unterschiedliche Versicherungsschutzsysteme.
                  </div>
                </div>
              </div>

              <br />
              <p id="cg">
                <b>Richtlinien</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading32">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse32"
                    aria-expanded="false"
                    aria-controls="flush-collapse32"
                  >
                    <b>
                      Muss ich das Fahrzeug reinigen, wenn ich es zurückbringe?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse32"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading32"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Ja. Bitte vergewissern Sie sich im Interesse des nächsten
                    Kunden, dass das Innere des Fahrzeugs am Ende der Mietzeit
                    in einem sauberen Zustand ist.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading33">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse33"
                    aria-expanded="false"
                    aria-controls="flush-collapse33"
                  >
                    <b>
                      Was ist, wenn das Fahrzeug innen oder außen nicht sauber
                      ist?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse33"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading33"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Wir bitten unsere Kunden, das Fahrzeug am Ende jeder
                    Anmietung sauber und aufgeräumt zu hinterlassen. Außerdem
                    werden die Fahrzeuge regelmäßig von uns gesäubert. Aber
                    bitte lassen Sie uns wissen, wenn Sie mit dem Zustand des
                    Fahrzeugs unzufrieden sind. Sie können dazu auch die
                    Funktion "Problem melden" in der App nutzen.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading26">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse26"
                    aria-expanded="false"
                    aria-controls="flush-collapse26"
                  >
                    <b>Darf ich im Fahrzeug rauchen?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse26"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading26"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nein. Rauchen ist in allen unseren Fahrzeugen verboten. Eine
                    Reinigungsgebühr wird Ihrer Rechnung hinzugefügt, wenn wir
                    während Ihres Mietzeitraums Beweise für das Rauchen im
                    Fahrzeug finden.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row shadow-lg p-3 mb-5 bg-body rounded">
          <a href="https:/l.ead.me/beWm77">
            <img
              className="img-fluid rounded-4"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/App_Banner-new-format%20DE.png"
              alt=""
              style={{
                width: "100vw",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          </a>
        </div>
      </div>
    </>
  );
}

export default FAQBody;
